import OnboardingStep from "./OnboardingStep"
import OnboardingDescription from "./OnboardingDescription"
import ValueTypeDocumentation from "../documentation/ValueTypeDocumentation"
import { ValueType } from "pokal_api"

const OnboardingContents: Record<OnboardingStep, OnboardingDescription> = {
    [OnboardingStep.POST_SIGN_UP]: {
        title: "Onboarding",
        content:
            "Herzlich Willkommen im Onboarding-Prozess. In den folgenden Schritten werden wir Ihnen die DOOR Studie Online Plattform vorstellen und mit Ihnen Schrtt für Schritt alle wichtigen Ansichten und Einstellungen durchgehen.",
        hideNextButton: false,
        forcePath: "/",
        position: "bottom_right"
    },
    [OnboardingStep.SHOW_NAV]: {
        title: "Navigationsleiste",
        content:
            "Im oberen Bereich der Seite könnnen Sie jetzt das Navigationsmenü sehen. Gerade befinden Sie sich in der Patient:innen-Auswahl. Egal wo sie sich auf der Plattform befinden, Sie können jederzeit über diese Leiste zu Ihrer gewünschten Ansicht wechseln.",
        hideNextButton: false,
        forcePath: "/"
    },
    [OnboardingStep.SHOW_NAV_LOGOUT]: {
        title: "Logout",
        content: "Mit einem Klick auf Logout können Sie sich abmelden.",
        hideNextButton: false,
        forcePath: "/"
    },
    [OnboardingStep.SHOW_PATIENT_SELECTION_VIEW]: {
        title: "Patient:innen-Auswahl",
        content:
            "Die Patient:innen-Auswahl ist die erste Seite die sich nach der Anmeldung öffnet. Sie besteht aus drei Hauptkomponenten, die wir Ihnen jetzt kurz vorstellen. Unterhalb finden Sie auch einen Link, der Sie zu den Schulungsunterlagen führt.",
        hideNextButton: false,
        forcePath: "/"
    },
    [OnboardingStep.SHOW_PATIENT_SELECTION_VIEW_OTP]: {
        title: "Ihr Einmal-Passwort",
        content:
            "Unten links sehen Sie Ihr individuelles Einmal-Passwort. Dieses müssen Sie an Ihre Patient:innen weitergeben, damit diese ihre App mit Ihrem Arzt-Account verbinden können. Nur so können Sie auf die gesammelten Patient:innen-Daten zugreifen.",
        hideNextButton: false,
        forcePath: "/"
    },
    [OnboardingStep.SHOW_PATIENT_SELECTION_VIEW_REQUESTS]: {
        title: "Patient:innen-Anfragen",
        content:
            "In der Patient:innen-Anfragen-Kachel sehen Sie eine Liste der Patient:innen, die Ihnen eine Verbindungsanfrage geschickt haben. Sie können diese annehmen oder ablehnen. Um dem Tutorial weiter zu folgen nehmen Sie bitte die Anfrage des Beispiel-Patienten Max Mustermann an. Hierzu klicken Sie bitte auf das grüne Häckchen beim Namen, um fortzufahren.",
        hideNextButton: true,
        forcePath: "/",
        position: "top_left"
    },
    [OnboardingStep.SHOW_PATIENT_SELECTION_VIEW_PATIENTS]: {
        title: "Patient:innen-Liste",
        content:
            "In der Patient:innen-Auswahl-Kachel im oberen Teil der Plattform finden Sie eine Liste aller Patient:innen, die mit Ihnen verbunden sind. Mit einem Klick auf den Namen können Sie eine Patient:in auswählen, um deren Daten zu sehen. Bitte wählen Sie den Beispiel-Patienten Max Mustermann aus um fortzufahren.",
        hideNextButton: true,
        forcePath: "/",
        position: "bottom_left"
    },
    [OnboardingStep.SHOW_PATIENT_OVERVIEW]: {
        title: "Patient:innen-Übersicht",
        content:
            "Sie sehen jetzt die Patient:innen-Übersicht für den Beispiel-Patienten Max Mustermann. Im Folgenden werden wir Ihnen Schritt für Schritt die Bestandteile der Übersicht vorstellen. Auf der Patientenübersicht sehen Sie alle wichtigen Informationen zu Ihrem Patienten oder Ihrer Patientin, komprimiert auf einer Seite. Jede Kachel enthält den aktuellen Wert zum Datenpunkt und eine Trendeinschätzung. Wenn Sie auf die Kacheln klicken, können Sie detailliertere Informationen in der Daten-Detail-Ansicht einsehen. Auf diese gehen wir später in der Anleitung ein.",
        hideNextButton: false,
        forcePath: "/patient/overview"
    },
    [OnboardingStep.SHOW_PATIENT_OVERVIEW_REPORT]: {
        title: "Bericht-Auswahl",
        content:
            "Hier können Sie die Berichte einsehen, die für diesen Patienten generiert wurden. Standardmäßig wird jeden Sonntagabend ein Bericht generiert. Sie können aber auch selbst Berichte generieren, indem Sie auf den betreffenden Button klicken.",
        hideNextButton: false,
        forcePath: "/patient/overview"
    },
    [OnboardingStep.SHOW_PATIENT_OVERVIEW_NOTES]: {
        title: "Notizen",
        content:
            "Um eine Notiz zu erstellen klicken SIe hier auf Notiz erstellen nachdem Sie das Textfeld ausgefüllt haben. Notizen sind versioniert, das heißt Sie können frühere Notizen überschreiben und haben dann immer noch Zugriff auf alle ehemaligen Änderungsschritte.",
        hideNextButton: false,
        forcePath: "/patient/overview"
    },
    [OnboardingStep.SHOW_PATIENT_OVERVIEW_PHQ]: {
        title: "PHQ-8",
        content: "Der PHQ-8-Fragebogen ist eine Kurzform des PHQ-9-Fragebogen (ohne Suizidalitätsfrage) und dient dem Screening und dem Monitoring von Depressionen. Er besteht aus acht Fragen zur Häufigkeit verschiedener depressiver Symptome in den letzten zwei Wochen. Der Patient oder die Patientin gibt mindestens einmal wöchentlich seine Antworten ab. Diese können Sie hier einsehen.",
        hideNextButton: false,
        forcePath: "/patient/overview"
    },
    [OnboardingStep.SHOW_PATIENT_OVERVIEW_SFQ]: {
        title: "SFQ",
        content: "Die Patient:in sollen vier Fragen zu Schwindel, Verstopfung, Sturz und sexueller Funktionsstörung alle zwei Wochen beantworten. Die Antworten fließen in die Medikationsanalyse ein. Hier können Sie die Antworten der SFQ Fragen einsehen.",
        hideNextButton: false,
        forcePath: "/patient/overview"
    },
    [OnboardingStep.SHOW_PATIENT_OVERVIEW_MOOD]: {
        title: "Stimmungserfassung",
        content: "Die Stimmungserfassung gibt Hinweise auf den emotionalen Zustand der Patient:in. Hier können Sie die Stimmungserfassung einsehen.",
        hideNextButton: false,
        forcePath: "/patient/overview"
    },
    [OnboardingStep.SHOW_PATIENT_OVERVIEW_SLEEP]: {
        title: "Schlafdaten",
        content: "Hier können Sie die nächtlich gesammelten Schlafdaten des Patienten oder der Patientin einsehen. Direkt ersichtlich ist die Schlafdauer, für die Einschlafdauer müssen Sie auf die Kachel klicken und in die Daten-Detailansicht wechseln. Auf die Detailansicht wird im späteren Verlauf der Anleitung noch eingegangen. ",
        hideNextButton: false,
        forcePath: "/patient/overview"
    },
    [OnboardingStep.SHOW_PATIENT_OVERVIEW_CARDIAC]: {
        title: "Nächtliche Herzdaten",
        content: "Hier können Sie die nächtlich gesammelten Herzdaten des Patienten oder der Patientin einsehen. Direkt ersichtlich ist die Herzfrequenz, für die Herzratenvariabilität müssen Sie auf die Kachel klicken und in die Daten-Detailansicht wechseln. Auf die Detailansicht wird im späteren Verlauf der Anleitung noch eingegangen.",
        hideNextButton: false,
        forcePath: "/patient/overview"
    },
    [OnboardingStep.SHOW_PATIENT_OVERVIEW_STEPS]: {
        title: "Schritte-Anzahl",
        content: "Hier sehen Sie die körperliche Aktivität des Patienten oder der Patientin in Form der zurückgelegten Schritte.",
        hideNextButton: false,
        forcePath: "/patient/overview"
    },
    [OnboardingStep.SHOW_PATIENT_OVERVIEW_MEDICATION]: {
        title: "Medikation",
        content: "Über die Medikation-Kachel gelangen Sie in die Medikationsansicht. Hier können Sie die Medikation des Patienten oder der Patientin einsehen. Bitte klicken Sie auf Weiter um fortzufahren.",
        hideNextButton: false,
        forcePath: "/patient/overview"
    },
    [OnboardingStep.SHOW_PATIENT_MEDICATION]: {
        title: "Medikationsansicht",
        content: "Die Medikationsansicht bündelt alle Angaben zur aktuellen Arzneitherapie einer Patientin oder eines Patienten, ermöglicht das schnelle Erfassen neuer Präparate und die Auswahl des jeweiligen Erfassungszeitpunkts. Auf Basis dieser Eingaben analysiert das System automatisch mögliche Risiken oder Übermedikation und liefert kompakte Hinweise für eine zielgerichtete Therapie‑Überprüfung. Hier sehen Sie den ersten Teil des Medikationsfragebogens für Patient Max Mustermann. Eine detailierte Beschreibung und Anleitung für das Medikationstool finden Sie in den Schulungsunterlagen.",
        hideNextButton: false,
        forcePath: "/dashboard/medication"
    },
    [OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ]: {
        title: "Daten-Detailansicht: PHQ8 ",
        content:
            "Um Sie mit der Daten-Detailansicht vertraut zu machen, werden wir Ihnen diese wie bei der Patient:innen-Übersicht Stück für Stück vorstellen.",
        hideNextButton: false,
        forcePath: "/patient/detail"
    },
    [OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_TREND]: {
        title: "Trendermittlung",
        content:
            "Die Trendermittlung zeigt den ermittelten Trend an. Dazu werden die Daten der letzten 2 Wochen mit den sog. Baseline-Daten (Daten der letzten 90 Tage) verglichen.",
        hideNextButton: false,
        forcePath: "/patient/detail"
    },
    [OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_LATEST]: {
        title: "Aktuellster Eintrag",
        content:
            "Den aktuellsten Eintrag können Sie auch in dieser Ansicht sehen. Diese Möglichkeit besteht nur für Datenkategorien mit absoluten Grenzwerten, also PHQ, SFQ und Stimmungserfassung.",
        hideNextButton: false,
        forcePath: "/patient/detail",
        position: "top_left"
    },
    //[OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_SETTINGS]: {
    //    title: "Daten-Ansicht Einstellungen",
    //    content:
    //        "Falls mehrere Datenpunkte an einem Tag zusammenkommen, können Sie diese wenn erwünscht aggregieren, so dass entweder eine maximale, minimale, durchschnittliche oder kombinierte Darstellung angezeigt wird.",
    //    hideNextButton: false,
    //    forcePath: "/patient/detail"
    //},
    [OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_CURRENT]: {
        title: "Aktuelle Daten",
        content: "Diese Ansicht zeigt Ihnen den Verlauf der Patient:in über die letzten 14 Tage. Sie können hier kurzfristige Trends erkennen und Veränderungen über zwei Wochen hinweg analysieren.",
        hideNextButton: false,
        forcePath: "/patient/detail",
        position: "bottom_right"
    },
    [OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_BASELINE]: {
        title: "Baseline Daten",
        content:
            "Im untersten Bereich können Sie die sog. Baseline-Daten sehen. Dabei handelt es sich um die Daten der letzten 90 Tage. Diese werden wie schon beschrieben verwendet um den Trend zu ermitteln.",
        hideNextButton: false,
        forcePath: "/patient/detail"
    },
    [OnboardingStep.SHOW_PATIENT_END]: {
        title: "Abschluss",
        content:
            "Vielen Dank, dass Sie am Tutorial teilgenommen haben. Sie können Dieses jederzeit wieder starten, indem sie auf jeder Seite ganz unten auf Onboarding klicken.",
        hideNextButton: false,
        forcePath: "/"
    }
}

export default OnboardingContents
